export const BASE = 'py-xl text-center text-[13px]';

export const TONE = {
	info: 'text-subtle',
	error: 'text-error',
} as const;
